import React from "react";
import DashboardCard from "./components/dashboardCard";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Stack, Container } from "@mui/material";
import { getGreeting } from "./utils/GreetingComponent";
import { useUserContext } from "../../context/auth/UserContext";

export const DashBoard = () => {
  const { isAppLoading, companyProlifeList, isLogoutClick } = useUserContext()
  return (
    <Container sx={{ m: 2, height: "100%" }}>
      <Grid
        container
        sx={{
          p: 7,
          maxWidth: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
        spacing={5}
      >
        <Grid sx={{ justifyContent: "center" }} xs={12}>
          <DashboardCard />
        </Grid>
      </Grid>
    </Container >
  );
};
